import React from "react";

function CarouselDots({
  slides,
  selected,
  onChange,
}: {
  slides: JSX.Element[];
  selected: number;
  onChange: Function;
}) {
  const selectedDotRef = React.useRef() as React.RefObject<HTMLDivElement>;
  const dotsContainerRef = React.useRef() as React.RefObject<HTMLDivElement>;
  const dotsListRef = React.useRef() as React.RefObject<HTMLDivElement>;

  React.useEffect(() => {
    const dotWidth = selectedDotRef.current?.clientWidth ?? 16;
    const dotsContainerNode = dotsContainerRef.current;
    const dotsListNode = dotsListRef.current;

    if (dotsContainerNode != null && dotsListNode != null) {
      const listener = () => {
        const dotsNodeWidth = dotsContainerNode?.clientWidth;
        const dotsListNodeWidth = dotsListNode?.scrollWidth;
        const hiddenWidth = dotsListNodeWidth - dotsNodeWidth;

        let translateX =
          dotWidth * (selected + 1) - (dotsNodeWidth - dotWidth * 2);

        if (translateX < 0) translateX = 0;
        if (translateX > hiddenWidth) translateX = hiddenWidth;

        dotsListNode.style.transform = `translateX(-${translateX}px)`;
      };

      window.addEventListener("resize", listener);
      listener();

      return () => {
        window.removeEventListener("resize", listener);
      };
    }
  }, [slides, selected]);

  return (
    <div className="carousel-dots-wrapper">
      <div ref={dotsContainerRef} className="carousel-dots">
        <div ref={dotsListRef} className="carousel-dots-list">
          {slides.map((_, i) => {
            const isSelected = selected === i;

            return (
              <div
                key={i}
                ref={isSelected ? selectedDotRef : undefined}
                className={["dot-wrap", isSelected ? "selected" : undefined]
                  .filter((e) => e)
                  .join(" ")}
              >
                <button
                  key={i}
                  type="button"
                  className="dot"
                  onClick={() => onChange(i)}
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default CarouselDots;
